export interface AppConfig {
  offlineThresholdMs: number;
  apiBase: string;
}

const env = import.meta.env;

export const config: AppConfig = {
  offlineThresholdMs: Number(env.VITE_OFFLINE_THRESHOLD_MS ?? 60_000),
  apiBase: env.VITE_API_BASE ?? "/api",
};
